import { PushComponent } from './../pushComponent/push.component';
import { LicenseManagerService } from './../../shared/licensemanager-service/licensemanager.service';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { Component, OnInit, Input } from '@angular/core';
import { SPHCompany, SPHLicense, SPHLoggedInUser, SPHApplication, SPHPhone } from '../../shared/shared';
import { Observable } from 'rxjs/Observable';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';

@Component({
    selector: 'lm-license-details',
    templateUrl: 'license-details.component.html'
})

export class LicenseDetailsComponent {
    private _company: SPHCompany;
    @Input() set company(company: SPHCompany) {
        this._company = company;
    }
    get company(): SPHCompany {
        return this._company;
    }

    private _user: SPHLoggedInUser;
    @Input() set user(user: SPHLoggedInUser) {
        this._user = user;
        this.setQRobservable();
        this.fetchDeviceInformation();
    }
    get user(): SPHLoggedInUser {
        return this._user;
    }

    private _availableApplications: SPHApplication[] = [];
    @Input() set availableApplications(availableApplications: SPHApplication[]) {
        this._availableApplications = availableApplications;
    }

    get availableApplications(): SPHApplication[] {
        return this._availableApplications;
    }

    private _license: SPHLicense;
    @Input() set license(license: SPHLicense) {
        this._license = license;

        if (license !== undefined) {
            this.onlyassigned = license.onlyassigned;
            this.extrainfos = license.extrainfos;
            this.loadprojectfiles = license.loadprojectfiles;
            this.setQRobservable();
            this.fetchDeviceInformation();
        }
    }
    get license(): SPHLicense {
        return this._license;
    }

    private _QRcodeImageObservable: Observable<any>;
    private deviceInformations: SPHPhone[];

    private onlyassigned = true;
    private extrainfos = false;
    private loadprojectfiles = false;

    constructor(private navParams: NavParams, private licenseManagerService: LicenseManagerService, private modalController: ModalController) {
        this.company = this.navParams.get('company');
        this.user = this.navParams.get('user');
        this.license = this.navParams.get('license');
        this.availableApplications = this.navParams.get('availableApplications');

        if (this.availableApplications === undefined) {
            this.loadApplications();
        }
    }

    public didTapSendPush(phones: SPHPhone[]) {
        const modal = this.modalController.create(PushComponent, { user: this.user, license: this.license, phones }, {enableBackdropDismiss: false});
        modal.present();
    }

    private applicationActive(application: SPHApplication) {
        if (this.license.applications.filter( (element) => element.id === application.id).length > 0) {
                return true;
            } else {
                return false;
            }
    }

    private fetchDeviceInformation() {
        if (this.license !== undefined && this.user !== undefined) {
            this.licenseManagerService.getPhones(this.license.id, this.user.jwt).subscribe( (phones) => {
              // @TODO liefert jetzt ein Array zurueck
              this.deviceInformations = phones;
              console.log(phones);
            });
        }
    }

    private setQRobservable() {
        if (this.license !== undefined && this.user !== undefined) {
            this._QRcodeImageObservable = this.licenseManagerService.qrCode(this.license.id, this.user.jwt);
        }
    }

    private loadApplications() {
        if (this.user !== undefined) {
            this.licenseManagerService.getApplications(this.user.jwt).subscribe((applications) => {
                this.availableApplications = applications;
            }, this.licenseManagerService.handleHttpError('Fehler bei Lizenzen-Abruf'));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/licenseDetailsComponent/license-details.component.ts